import {Injectable} from '@angular/core';

@Injectable()
export class AuthorisedSideNavService {
    hideSideNav = false;

    constructor() {
    }

    toggleSideNav(): void {
        this.hideSideNav = !this.hideSideNav;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/layout/authorised/services/authorised-side-nav.service.ts